import { Link, useLocation } from 'react-router-dom';

export interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600">
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {!isLast && item.url ? (
                <Link
                  to={item.url}
                  className="hover:text-primary-500 transition-colors duration-200"
                >
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-900 font-medium' : 'text-foreground-600'}>
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}